/**
  * 热门搜索 接口的统一出口
  */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/'

const searchdata = {
  // 查询
  list (params) {
    return axios.get(api + 'hotsearch/list', { params: params })
  },
  // 添加
  create (params) {
  	return axios.post(api + 'hotsearch/create', qs.stringify(params))
  },
  // 删除
  remove (params) {
    return axios.post(api + 'hotsearch/remove', qs.stringify(params))
  },
  // 排序
  sort (params) {
    return axios.post(api + 'hotsearch/sort', qs.stringify(params))
  }
}

// 导出接口
export default searchdata
